import React, { useEffect, useState, useContext, useMemo } from 'react'
import TripsContext from '../../contexts/TripsContext'
import { InfoWindow, Marker } from '@react-google-maps/api'
import { useMarkers } from '../../hooks/useMarker'
import { createMarkerInfoWindow } from '../../infowindow-utils'
import { ICON_STOP } from '../InfoWindowMarker/index'

type IProps = {
    trips: any[]
}

const MarkerTrip = ({ trips }: IProps) => {
    const { reverseGeocoding, tripHoverActive, setTripHoverActive, setInfoWindow } = useContext(TripsContext)
    const [markers, setMarkers] = useState<any[]>([])

    const onMouseOver = id => {
        const trip = trips.find(({ uid }) => uid === id)
        setTripHoverActive({ ...trip, ...{ slide: true } })
    }

    const onMouseDown = id => {
        setTripHoverActive(undefined)
    }

    const onClick = (id, reverseGeocoding) => {
        const trip = trips.find(({ uid }) => uid === id)
        const popup = createMarkerInfoWindow(trip, ICON_STOP, reverseGeocoding, undefined)
        setInfoWindow(popup)
    }

    const buildMarkers = (trips, tripHoverActive) => {
        const markersCustom: any[] = []

        trips
            // ?.filter((trip, index) => {
            //     return index !== 0
            // })
            .forEach(trip => {
                const { lat, lng, uid } = trip

                const icon = {
                    url:
                        tripHoverActive?.uid === uid
                            ? '/content/plugin-widget-gmaps/marker-square-hover.svg'
                            : '/content/plugin-widget-gmaps/marker-square.svg',
                    scaledSize: new google.maps.Size(15, 15)
                }

                const options = { icon }

                markersCustom.push({ id: uid, lat, lng, options })
            })

        return markersCustom
    }

    useEffect(() => {
        const aux = buildMarkers(trips, tripHoverActive)
        setMarkers(aux)
    }, [trips, reverseGeocoding, tripHoverActive])

    return (
        <>
            {markers.map(({ id, lat, lng, options }) => {
                return (
                    <Marker
                        key={id}
                        onMouseOver={() => onMouseOver(id)}
                        onMouseOut={() => onMouseDown(id)}
                        onClick={() => {
                            onClick(id, reverseGeocoding)
                        }}
                        options={options}
                        position={{ lat, lng }}
                    />
                )
            })}
        </>
    )
}

export default React.memo(MarkerTrip)
